import {colors} from 'ui/config';
import PropType from 'prop-types';

const styleFullWidth = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  marginBottom: 10,
};

const styleSVG = {width: 53, marginLeft: 20, opacity: 0.65};
const styleSVGFullWidth = {width: 70, opacity: 0.75, marginLeft: 35};

export const Loading = ({loadingFullWidth = false, loadingHidden = false}) =>
  !loadingHidden ? (
    <div style={loadingFullWidth ? styleFullWidth : null}>
      <svg
        style={loadingFullWidth ? styleSVGFullWidth : styleSVG}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 100 100">
        <circle fill={colors.caramel} stroke="none" cx="6" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle fill={colors.caramel} stroke="none" cx="26" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
        <circle fill={colors.caramel} stroke="none" cx="46" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
      </svg>
    </div>
  ) : null;

Loading.propTypes = {
  loadingFullWidth: PropType.bool,
  loadingHidden: PropType.bool,
};

export const loadingIf =
  (condition, {loadingFullWidth, loadingHidden}) =>
  C =>
  props =>
    condition(props) ? (
      <Loading {...props} loadingFullWidth={loadingFullWidth} loadingHidden={loadingHidden} />
    ) : (
      <C {...props} />
    );
